
import { Component, Vue } from 'vue-property-decorator';
import TumsHeader from '@/page/header/index.vue';
const { tumsAxios } = window['tums-components'].default.Utils.data;
@Component({
    components: {
        TumsHeader
    }
})
export default class App extends Vue {
    get logined() {
        return this.$store.getters.hasPermission === undefined || this.$store.getters.hasPermission;
    }
}
